import NetworkError from "../../components/NetworkError";
import Preloader from "../../components/Preloader";
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { config } from "../../constants/config";
import { useEffect } from "react";
import { Asterisk, Calendar, Table, TextIndentLeft, TextLeft, TextParagraph } from "react-bootstrap-icons";
import UserContext from "../../contexts/UserContext";
import { textes } from "../../constants/textes";



export default function DomainInfos({codedomaine}) {
    // states
    const {user, logoutUser} = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [editedstate, setEditedstate] = useState(false);
    const [error, setError] = useState(false);

    const [type, setType] = useState(0);
    const [nomtab, setNomtab] = useState("");
    const [prefdom, setPrefdom] = useState("");
    const [libdom, setLibdom] = useState("");
    const [nomtabparent, setNomtabparent] = useState("");
    const [nomtabparent1, setNomtabparent1] = useState("");
    const [nomtabparent2, setNomtabparent2] = useState("");
    const [libtitrevueliste, setLibtitrevueliste] = useState("");
    const [libtitrevuenouveau, setLibtitrevuenouveau] = useState("");
    const [libtitrevueedit, setLibtitrevueedit] = useState("");
    const [etat, setEtat] = useState("");
    const [datecrea, setDatecrea] = useState("");
    const [dateupda, setDateupda] = useState("");
    const [card, setCard] = useState("");

    const listype = [
        {
            value: 1,
            label: "Domaine de type 1",
        },
        {
            value: 2,
            label: "Domaine de type 2",
        },
        {
            value: 3,
            label: "Domaine de type 3",
        },
        {
            value: 4,
            label: "Domaine de type 4",
        },
    ];


    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }



    const getDomaine = async () => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.domain.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/domains/${codedomaine}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let body = data?.body?.data[0];

                        setType(body?.type !== null ? {value : body?.type, label: "Domaine de type "+body?.type} : "");
                        setNomtab(body?.nomtab !== null ? body?.nomtab : "");
                        setPrefdom(body?.pref !== null ? body?.pref : "");
                        setLibdom(body?.lib !== null ? body?.lib : "");
                        setNomtabparent(body?.nomtabparent ? body?.nomtabparent : "Aucun parent");
                        setNomtabparent1(body?.nomtabparent1, body?.nomtabparent1);
                        setNomtabparent2(body?.setnomtabparent2 !== null ? body?.setnomtabparent2 : "");
                        setLibtitrevueliste(body?.libtitrevuelist !== null ? body?.libtitrevuelist : "");
                        setLibtitrevuenouveau(body?.libtitrevuenouv !== null ? body?.libtitrevuenouv : "");
                        setLibtitrevueedit(body?.libtitrevueedit !== null ? body?.libtitrevueedit : "");
                        setEtat(body?.etat !== null ? body?.etat : "");
                        setCard(body?.card !== null ? body?.card : "");
                        setDatecrea(body?.datecrea !== null ? body?.datecrea.slice(0, 10) : "");
                        setDateupda(body?.dateupda !== null ? body?.dateupda.slice(0, 10) : "");

                        setLoading(false);
                    } else {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }
            
        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    }


    // comportements
    useEffect(() => {
        getDomaine();
    }, [])

    const handleDelete = async () => {
        confirmAlert({
            title: 'Supprimer?',
            message: 'Etes-vous sûr de vouloir supprimer ce domaine? Cette action entraînera la suppression automatique de des nomenclatures.',
            buttons: [
                {
                    label: "Confirm",
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setFetching(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.domain.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var requestOptions = {
                            method: 'DELETE',
                            headers: myHeaders,
                            // body: urlencoded,
                            redirect: 'follow'
                        };


                        // console.log("data send", urlencoded);

                        await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/domains/${codedomaine}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                setFetching(false);
                                showSuccesMessage("Domaine supprimé avec succès.");
                                setEditedstate(false);
                                navigate(-1);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse delete droit", data);
                                    if (data?.body?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else if (data?.body?.msg === "ce domaine est actuellement en cours d'utilisation") {
                                        setFetching(false);
                                        showErrorMessage("Impossible de supprimer un domaine utilisé.");
                                    } else {
                                        setFetching(false);
                                        showErrorMessage(textes.fr.oparationfail);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                                setFetching(false);
                            }
                            
                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                            setFetching(false);
                        });
                    }
                }, 
                {
                    label: "Cancel",
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }


    const handleSubmitEdit = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: 'Mise à jour?',
            message: 'Etes-vous sûr de vouloir mettre à jour ce domaine?',
            buttons: [
                {
                    label: "Confirm",
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setFetching(true);
                        
                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.domain.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        urlencoded.append("lib", libdom);
                        urlencoded.append("defaut", false);
                        urlencoded.append("edit", true);
                        // urlencoded.append("list", libtitrevueliste);
                        // urlencoded.append("nouv", libtitrevuenouveau);
                        // urlencoded.append("edit", libtitrevueedit);

                        var requestOptions = {
                            method: 'PUT',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        // console.log("data send", urlencoded)

                        await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/domains/${codedomaine}`, requestOptions).then((response) => {
                            if (response?.status === 204) {
                                showSuccesMessage("Domaine mis à jour avec succès.");
                                setEditedstate(false);
                                getDomaine();
                                setFetching(false);

                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    // let body = data?.body;

                                    if (data?.body?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setFetching(false);
                                        showErrorMessage("Echec de la mise à jour du domaine! Veuillez reassayer plutard.");
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                                setFetching(false);
                            }
                            
                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                            setFetching(false);
                        });
                    }
                }, 
                {
                    label: "Cancel",
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }



    // affichages
    return (
        <>
            {loading && <Preloader />}
            {!loading && error && <NetworkError />}
            {!loading && !error && <div className="row"> 
                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <button onClick={() => navigate(-1)} data-toggle="tooltip" title="Quit" data-placement="left" className="btn-shadow ml-3 btn btn-dark btn-sm float-right">
                                        <i className="fa fa-reply"></i> <span>Go Back</span>
                                    </button>
                                    {!editedstate && <button onClick={() => setEditedstate(true)}
                                        title="Modifier le domaine" 
                                        className="btn-shadow ml-3 btn btn-success btn-sm float-right">
                                        <i className="fa fa-edit mr-1"></i> <span>Modifier</span>
                                    </button>}
                                    {!editedstate && <button onClick={handleDelete}
                                        title="Supprimer le domaine" 
                                        className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                        <i className="fa fa-trash mr-1"></i> <span>Supprimer</span>  {deleting && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                        />}
                                    </button>}
                                    <h6 className="m-0 ">Informations du domaine</h6>
                                </div>
                                <div className="card-body">
                                    <form style={{width: "100%"}} onSubmit={handleSubmitEdit}>
                                        <div className="row">
                                            <div className="col-md-12 mb-3">
                                                <div className="row">
                                                    {/* <div className="col-md-6 mb-3">
                                                        <label htmlFor="type" className="mb-1">Type de domaine</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="type">
                                                                <TypeH1 />
                                                            </span>
                                                            <input type="text" 
                                                                className="form-control" 
                                                                placeholder=""
                                                                value={type}
                                                                onChange={(e) => setType(e.target.value)}
                                                                disabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                    </div> */}
                                                    <div className="col-md-6 mb-3">
                                                        <label className="mb-1" htmlFor="type">Type de domaine</label>
                                                        <Select
                                                            id="type"
                                                            name="type"
                                                            options={listype}
                                                            value={type}
                                                            onChange={(selected) => { setType(selected); }}
                                                            isDisabled
                                                        />
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="lib" className="mb-1">Libelle</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="lib">
                                                                <TextParagraph />
                                                            </span>
                                                            <input type="text" 
                                                                className="form-control" 
                                                                placeholder=""
                                                                value={libdom}
                                                                onChange={(e) => setLibdom(e.target.value)}
                                                                disabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="table" className="mb-1">Nom table</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="table">
                                                                <Table />
                                                            </span>
                                                            <input type="text" 
                                                                className="form-control" 
                                                                placeholder=""
                                                                value={nomtab}
                                                                onChange={(e) => setNomtab(e.target.value)}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="pref" className="mb-1">Préfix</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="pref">
                                                                <TextLeft />
                                                            </span>
                                                            <input type="text" 
                                                                className="form-control" 
                                                                placeholder=""
                                                                value={prefdom}
                                                                onChange={(e) => setPrefdom(e.target.value)}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="tableparent1" className="mb-1">Nom table parent </label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="tableparent1">
                                                                <Table />
                                                            </span>
                                                            <input type="text" 
                                                                className="form-control" 
                                                                placeholder=""
                                                                value={nomtabparent}
                                                                onChange={(e) => setNomtabparent(e.target.value)}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* <div className="col-md-6 mb-3">
                                                        <label htmlFor="tableparent2" className="mb-1">Nom table parent niveau 2</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="tableparent2">
                                                                <Table />
                                                            </span>
                                                            <input type="text" 
                                                                className="form-control" 
                                                                placeholder=""
                                                                value={nomtabparent1}
                                                                onChange={(e) => setNomtabparent1(e.target.value)}
                                                                disabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="tableparent2" className="mb-1">Nom table parent niveau 2</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="tableparent2">
                                                                <Table />
                                                            </span>
                                                            <input type="text" 
                                                                className="form-control" 
                                                                placeholder=""
                                                                value={nomtabparent2}
                                                                onChange={(e) => setNomtabparent2(e.target.value)}
                                                                disabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                    </div> */}
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="libtitrevueliste" className="mb-1">Libelle titre vue liste</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="libtitrevueliste">
                                                                <TextIndentLeft />
                                                            </span>
                                                            <input type="text" 
                                                                className="form-control" 
                                                                placeholder=""
                                                                value={libtitrevueliste}
                                                                onChange={(e) => setLibtitrevueliste(e.target.value)}
                                                                disabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="libtitrevuenouveau" className="mb-1">Libelle titre vue nouveau</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="libtitrevuenouveau">
                                                                <TextIndentLeft />
                                                            </span>
                                                            <input type="text" 
                                                                className="form-control" 
                                                                placeholder=""
                                                                value={libtitrevuenouveau}
                                                                onChange={(e) => setLibtitrevuenouveau(e.target.value)}
                                                                disabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="libtitrevueedit" className="mb-1">Libelle titre vue mise à jour</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="libtitrevueedit">
                                                                <TextIndentLeft />
                                                            </span>
                                                            <input type="text" 
                                                                className="form-control" 
                                                                placeholder=""
                                                                value={libtitrevueedit}
                                                                onChange={(e) => setLibtitrevueedit(e.target.value)}
                                                                disabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="datecrea" className="mb-1">Date de création</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="datecrea">
                                                                <Calendar />
                                                            </span>
                                                            <input type={editedstate ? "date" : "text"} 
                                                                className="form-control" 
                                                                placeholder=""
                                                                value={datecrea}
                                                                onChange={(e) => setDatecrea(e.target.value)}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="dateupda" className="mb-1">Date de dernière mise à jour</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="dateupda">
                                                                <Calendar />
                                                            </span>
                                                            <input type={editedstate ? "date" : "text"} 
                                                                className="form-control" 
                                                                placeholder=""
                                                                value={dateupda}
                                                                onChange={(e) => setDateupda(e.target.value)}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mb-3">
                                                        <label htmlFor="etat" className="mb-1">Etat du domaine</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className={`input-group-text ${
                                                                    etat === 1 ? "bg-warning" :
                                                                    etat ===2 ? "bg-success" :
                                                                    ""
                                                                }`
                                                            } 
                                                                id="etat"
                                                            >
                                                                <Asterisk />
                                                            </span>
                                                            <input
                                                                readOnly
                                                                type="text" 
                                                                className={`form-control ${
                                                                        etat === 1 ? "text-white bg-warning" :
                                                                        etat ===2 ? "text-white bg-success" :
                                                                        ""
                                                                    } 
                                                                `} 
                                                                id="etat"
                                                                value={
                                                                    etat === 1 ? "Domaine non utilisé" :
                                                                    etat ===2 ? "Domaine utilisé" :
                                                                    ""
                                                                }
                                                                placeholder=""
                                                                onChange={(e) => setEtat(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                            {editedstate && <div className="col-md-12 mt-2">
                                                <button type="submit" 
                                                    title="Mise à jour du domaine" 
                                                    className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                    // disabled={names && statusinput["value"] ? false : true}
                                                >
                                                    <i className="fa fa-check mr-2"></i> 
                                                    <span>Modifier</span> {fetching && <Spinner
                                                            as="span"
                                                            animation="border"
                                                            size="sm"
                                                            role="status"
                                                            aria-hidden="true"
                                                    />}
                                                </button>
                                                <button onClick={() => setEditedstate(false)} 
                                                    title="Annuler l'operation"
                                                    className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                                    <i className="fa fa-reply mr-1"></i> <span>Annuler</span>
                                                </button>
                                            </div>}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ToastContainer />
                </div>
            </div>}
        </>
    )
}